import {
    EVENT_NAME_IMPRESSION,
    EVENT_NAME_CLICK,
    EVENT_DATA_TYPE_JOB
} from "@/js/eventReport/constants";
import { Signaler } from "@/js/eventReport/components/Signaler";

class JobEventReporter {
    static send(eventName, eventParams) {
        Signaler.send(eventName, { data_type: EVENT_DATA_TYPE_JOB, ...eventParams });
    }

    static sendImpression({ id, title, enterpriseName }) {
        JobEventReporter.send(EVENT_NAME_IMPRESSION, {
            identifier: id,
            job_title: title,
            enterprise_name: enterpriseName
        });
    }

    static sendClick({ id, title, enterpriseName }) {
        JobEventReporter.send(EVENT_NAME_CLICK, {
            identifier: id,
            job_title: title,
            enterprise_name: enterpriseName
        });
    }
}

export { JobEventReporter };
